  import React from "react";
import ReactDOM, { Root } from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./Contexts/AuthContext";
import { createTheme, ThemeProvider } from "@mui/material";

const root: Root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const fontFamily = "Josefin Sans";
// const labelColor = "rgba(0, 0, 0, 0.6)"
const labelColor = "#979797"


const theme = createTheme(
  { 
  palette: {
    primary: {
      main: '#5B8C51',
      // main: '#5B8C51',
    },
    // secondary: {
    //   // main: '#078ED11A',
    //   // main: '#5B8C51',
    // },
  },
  typography: {
    fontFamily: fontFamily,
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& label': {
            fontSize:"0.875rem",
            fontWeight:"500"
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: fontFamily,
          fontSize: '14px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select:{
          padding:"8px 14px !important",
          fontSize:"0.875rem",
          fontWeight:"500",
          color:labelColor,
          opacity:"1",
        },
        icon: {
          color: 'rgb(34, 43, 66)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          height: '20px', 
          padding: '11px 14px 8px !important', 
          "&::placeholder": {
            fontSize:"0.875rem",
            fontWeight:"500",
            lineHeight:"1",
            color:labelColor,
            opacity:"1"
          },
        },
        root:{
          span :{
            fontSize : "10px !important"
          },
          "& ::-webkit-datetime-edit-month-field": { textTransform: "uppercase" },
          "& ::-webkit-datetime-edit-day-field": {   textTransform: "uppercase" },
          "& ::-webkit-datetime-edit-year-field": {  textTransform: "uppercase" },
          "& input[type='file']" : {
            padding:"9px 10px 10px !important",
            "&::file-selector-button":{
              height:"25px",
              fontSize:"14px"
            }
          },
          "& input[type='date']" : {
            color: labelColor,
            fontFamily: fontFamily,
            fontWeight: "500",
            fontSize: "14px",
          }
        }
      },
    },
    MuiButton:{
      styleOverrides: {
        root:{
          borderRadius: '6px',
          padding: '8px 24px',
          boxShadow : "none",
          textTransform : "capitalize"
        },
        startIcon: {
          marginRight: '4px',
        },
     }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#F4F7F9",
          color: "#202224",
        },
        body: {
          color: "#606060",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "& td" : {
            padding: "10px",
            borderBottom : "1px dashed #6A71854D",
          }
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          marginTop : "25px"
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginRight : "0"
        },
      },
    },
  },
})

root.render(
  <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <App />
          <ToastContainer />
        </AuthProvider>
      </ThemeProvider>
  </Provider>
);
